import React, { FunctionComponent } from "react";
import { Dropdown } from "react-bootstrap";
import { useDispatch } from "react-redux";
import UploadStudentDemographicModal from "./UploadStudentDemographicModal";
import { openUploadStudentDemographicModal } from "../../../../../store/onboarding/actions";
import useUserRole from "../../../../../utils/hooks/useUserRole";

type OwnProps = {};

type Props = OwnProps;

const UploadStudentDemographicsCsvButton: FunctionComponent<Props> = (
  props
) => {
  const dispatch = useDispatch();
  const { isTeacher } = useUserRole();
  return (
    <>
      {isTeacher 
      ? <button 
          className="whiteBtnSm text-nowrap" 
          onClick={() => dispatch(openUploadStudentDemographicModal())}
        >
          Upload Demographics
        </button>
      :
        <Dropdown.Item
          as="button"
          onClick={() => {
            dispatch(openUploadStudentDemographicModal());
          }}
          className="text-wrap"
        >
          Upload Demographics
        </Dropdown.Item>
      }
      <UploadStudentDemographicModal />
    </>
  );
};

export default UploadStudentDemographicsCsvButton;
